import {Directive} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validators} from "@angular/forms";

@Directive({
  selector: '[appIdentityRevealed]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidatorsPersonaFisica, multi: true }]
})
/**
 * Raccolta di Validator fondamentali per una persona fisica
 *
 * Validators:
 * {@link checkCodiceFiscaleCompleto}
 */
export class ValidatorsPersonaFisica extends Validators{
  constructor() {super();}

  /**
   * Validator del Codice Fiscale Completo
   *
   * @returns Ritorna `null` se viene passato il controllo, altrimenti restituisce un oggetto {@link ValidationErrors} con il campo `invalidFormat` a `true`
   *
   * @param control di tipo `FormControl`, `FormGroup` o `FormArray`.
   */
  public static checkCodiceFiscaleCompleto(control: AbstractControl): ValidationErrors | null {
    const regexPattern = /(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]/;

      const value = control.value;
      if (value && !regexPattern.test(value))
        return {invalidFormat: true};

      return null;
  }


}
